export const defaultbaseUrl = 'https://api.sipamer.4visionmedia.net/api/'
export const assetUrl = 'https://api.sipamer.4visionmedia.net/'
export const storageUrl = 'https://api.sipamer.4visionmedia.net/storage/'
